import React from "react"
import Link from "next/link"
import * as styles from "./Breadcrumbs.module.scss"

const Breadcrumbs = (props) => {
  const sep = " > "
  const breadcrumbs = props.elements.map((element, i) => (
    <span key={i}>
      {Array.isArray(element) ? (
        <>
          {sep}
          <Link href={element[1]}>
            <a>{element[0]}</a>
          </Link>
        </>
      ) : (
        sep + element
      )}
    </span>
  ))
  let classes = `${styles[props.color]}`
  classes += ` ${props.desktopColor ? styles[`desktop_${props.desktopColor}`] : ""}`
  classes += ` ${styles.Breadcrumbs}`
  return (
    <div className={classes}>
      <Link href="/">
        <a>Home</a>
      </Link>
      {breadcrumbs}
    </div>
  )
}

export default Breadcrumbs
